// A busca de produtos manda só `has_spot_components` (BDM-1157); a estrutura
// chega pelo detalhe (`/product/{id}`). O array continua valendo para o
// backend antigo e para o produto já carregado.
export const productHasSpotComponents = (product) => {
    if (product?.origin !== 'integracao_spot') return false;
    if (Array.isArray(product.spot_components)) return product.spot_components.length > 0;
    return Boolean(product.has_spot_components);
};

const STANDARD_AREA = '99.9 x 99.9';

const formatCentimeters = (area) => area.replace(/(\d+(?:[.,]\d+)?)(?=\s*x|\s*$)/g, (match) => {
    const formatted = String(parseFloat(match.replace(',', '.')));
    return `${match.includes(',') ? formatted.replace('.', ',') : formatted} cm`;
});

// O valor da opção continua sendo o `AreaCM`: é ele que fica salvo no orçamento
// (`spot_area`) e que escolhe as cores. Só o texto usa o `PrintAreaCM`, a conta
// do backend que reproduz o configurador da Spot (BDM-1187).
export const spotAreaLabel = (option) => {
    if (option.AreaCM === STANDARD_AREA) return 'Tamanho padrão';
    return formatCentimeters(option.PrintAreaCM || option.AreaCM);
};
